import axios from 'axios';

export const replyActionApi = (projectId, actionId, data) =>
	axios.put(`/api/projects/${projectId}/confirmationActions/${actionId} `, data);
